import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async remove ({ state, dispatch }) {
    try {
      await directus.deleteItem('directus_users', state.id)
      const seatingStatus = await directus.getItems('member_seating_status', {
        filter: {
          user: {
            eq: state.id
          }
        }
      })
      await directus.deleteItem('member_seating_status', seatingStatus.data[0].id)

      return true
    } catch (err) {
      errorDirectus(err, dispatch)
      return false
    }
  }
}
